(function () {
  'use strict';
  const rules = window.OtelloGiftRules;
  if (!rules) return;

  function render(panel, line, choice, currency = 'GBP') {
    const value = rules.offer(line, currency);
    panel.hidden = !value;
    if (value) {
      const title = panel.querySelector('[data-gift-card-title]');
      title.textContent = title.dataset.giftCardTemplate.replace('[amount]', value.faceValuePence / 100);
      panel.querySelectorAll('[data-gift-card-amount]').forEach(el => { el.textContent = value.faceValuePence / 100; });
    }
    for (const checkbox of panel.querySelectorAll('[data-gift-kind]')) {
      checkbox.disabled = !value;
      checkbox.checked = Boolean(value && choice && choice.parentKey === line.key && choice.kind === checkbox.dataset.giftKind);
    }
  }

  window.OtelloGiftUI = { render };

  function initEditor(scope) {
    scope.querySelectorAll('[data-gift-editor-preview]').forEach(wrapper => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';
      const data = JSON.parse(wrapper.querySelector('[data-gift-product-json]').textContent);
      const panel = wrapper.querySelector('[data-free-gift]');
      if (!panel) return;
      const buyBox = wrapper.closest('.yv-main-product-detail');
      const input = buyBox && buyBox.querySelector('form[action*="/cart/add"] [name="id"]');
      let choice = null;
      function line() {
        const variant = data.variants.find(v => String(v.id) === String(input ? input.value : data.selectedVariant));
        return { key: 'editor', productId: data.id, vendor: data.vendor, tags: data.tags, quantity: 1,
          compareAtPence: variant ? variant.compare_at_price : undefined,
          originalLinePence: variant ? variant.price : null, discountAllocations: [] };
      }
      function update() {
        if (!rules.offer(line(), data.currency)) {
          if (choice) wrapper.querySelector('[role="status"]').textContent = 'Your gift selection was removed because this variant no longer qualifies. Gifts are available on full-price items only.';
          choice = null;
        }
        render(panel, line(), choice, data.currency);
      }
      panel.addEventListener('change', event => {
        const checkbox = event.target.closest('[data-gift-kind]');
        if (!checkbox || !rules.offer(line(), data.currency)) return;
        choice = checkbox.checked ? { kind: checkbox.dataset.giftKind, parentKey: 'editor' } : null;
        update();
        wrapper.querySelector('[role="status"]').textContent = choice ? 'Preview selection updated. No gift has been added to the basket.' : 'Preview selection removed.';
      });
      if (input) input.addEventListener('change', update);
      update();
    });
  }
  initEditor(document);
  document.addEventListener('shopify:section:load', event => initEditor(event.target));
})();
